module.exports = __webpack_public_path__ + "img/ES.e36e0f21.png";